import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import ArticleMenu from './ArticleMenu.vue'
import { Getters, Mutations } from '../../store/manager/helpers'
import attachmentUrl from '../../filters/attachment-url'
import { ArticleData } from '../../store/manager/state'
import { unescapeHtmlEntity } from '../../misc/html-entity'

@Component({
  props: {
    val: {
      type: Object, /* ArticleData */
      required: true
    }
  },
  components: {
    'article-menu': ArticleMenu
  }
})
export default class ArticleCardType extends Vue {
  name: 'ContentsManage'
  $store: Store<RootState>
  readonly val: ArticleData
  isMenuVisible: boolean = false

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  get contentId(): number {
    const contentId = this.val.contentId
    if (!contentId) {
      throw new Error('コンテンツIDがありません')
    }
    return contentId
  }

  get dropDownMenuId() {
    return 'dropdown-menu' + this.contentId
  }

  get selected(): boolean {
    return !!this.val.selected
  }

  set selected(selected: boolean) {
    Mutations.updateContentSelection(this.$store, {
      selected,
      contentId: this.contentId
    })
  }

  get articleImage(): string {
    return this.val.image || ''
  }

  get imageUrl(): string {
    return attachmentUrl(this.articleImage, this.siteId, this.contentId)
  }

  toggleMenu(): void {
    this.isMenuVisible = !this.isMenuVisible
  }

  hideMenu(): void {
    this.isMenuVisible = false
  }

  menuSelected(componentName: string) {
    this.hideMenu()
    return this.$emit('menu-selected', componentName)
  }

  decodeDescription(description: string): string {
    return unescapeHtmlEntity(description)
  }
}
